import * as React from "react";
import { cn } from "@/lib/utils";

export interface InputProps extends React.ComponentProps<"input"> {
  warning?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, warning, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        data-slot="input"
        className={cn(
          "file:text-foreground bg-background font-light placeholder:text-muted-foreground placeholder:text-sm selection:bg-primary selection:text-primary-foreground border-ring/50 dark:bg-input/50 flex h-10 md:h-9 w-full min-w-0 rounded-[var(--radius)] border px-3 py-1 text-base shadow-[0_4px_16px_rgba(0,0,0,0.1)] hover:shadow-[0_3px_12px_rgba(0,0,0,0.15)] dark:shadow-[0_4px_16px_rgba(0,0,0,0.15)] dark:hover:shadow-[0_6px_24px_rgba(0,0,0,0.2)] transition-all outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm opacity-70 focus-visible:opacity-100",
          "focus-visible:border-ring/70 focus-visible:ring-ring/30 focus-visible:ring-1",
          "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
          warning &&
            "border-yellow-500 ring-yellow-500/20 ring-1 dark:border-yellow-600 dark:ring-yellow-600/20",
          "relative z-10",
          className,
        )}
        {...props}
      />
    );
  },
);

Input.displayName = "Input";

export { Input };
